<template>
  <div id="flow-chart-two" class="flow-chart-two" width="1100" height="1400"></div>
</template>
<script>
import { dia, shapes, highlighters, linkTools } from '@joint/core';
const unit = 4;
const bevel = 1 * unit;
const spacing = 2 * unit;
const fillColor = '#404040';
const fontAttributes = {
  fontFamily: "PPFraktionSans, sans-serif",
  fontStyle: "normal",
  fontSize: 14,
  lineHeight: 18
};
export default {
  name: 'FlowChartTwo',
  data() {
    return {
      paper: null,
      graph: null,
      graphBBox: null,
    };
  },
  async mounted() {
    this.init()
    // this.transformToFitContent();
    // window.addEventListener("resize", this.transformToFitContent);
    const container = document.querySelector('.right-content');
    const draggable = document.querySelector('#flow-chart-two');

    draggable.ontouchstart = function (ev) {
      const { clientX, clientY } = ev.touches[0]

      const x = clientX - draggable.offsetLeft + container.scrollLeft;
      const y = clientY - draggable.offsetTop + container.scrollTop;

      draggable.ontouchmove = function (ev) {
        draggable.style.left = ev.touches[0].clientX - x + 'px';
        draggable.style.top = ev.touches[0].clientY - y + 'px';

        ev.preventDefault();
      }

      draggable.ontouchend = function (ev) {
        draggable.ontouchmove = null;
        draggable.ontouchend = null;
      }

      return false;
    }



  },
  methods: {
    init() {
      const paperContainer = document.getElementById("flow-chart-two");
      this.graph = new dia.Graph({}, { cellNamespace: shapes });

      this.paper = new dia.Paper({
        model: this.graph,
        cellViewNamespace: shapes,
        // width: "100%",
        // height: "100%",
        width: "1100px",
        height: "1400px",
        async: true,
        sorting: dia.Paper.sorting.APPROX,
        background: { color: "transparent" },
        snapLabels: true,
        clickThreshold: 10,
        interactive: false,
        // useTouch: true,
        gridSize: 5,
        defaultConnectionPoint: {
          name: "boundary",
          args: {
            offset: spacing,
            extrapolate: true
          }
        },
        defaultRouter: { name: "rightAngle", args: { margin: unit * 7 } },
        defaultConnector: {
          name: "straight",
          args: { cornerType: "line", cornerPreserveAspectRatio: true }
        } // bevelled path
      });

      paperContainer.appendChild(this.paper.el);
      this.generChart();
      this.graphBBox = this.graph.getBBox();
      this.eventHandle()
    },
    generChart() {
      const title1 = new (this.createText({ x: 150, y: 30, text: '人遗准备说明' }));
      const title2 = new (this.createText({ x: 790, y: 30, text: '在线申请材料' }));

      const step1 = this.createStep({ x: 60, y: 60, w: 160, h: 60, text: "申请单位向科技部\n申请账号和密码" });
      const step2 = this.createStep({ x: 25, y: 180, w: 230, h: 60, text: "登录网上平台\nhttps://apply.hgrg.net/login"});
      const step3 = this.createStep({ x: 60, y: 300, w: 160, h: 60, text: "在线填报申请资料" });
      const step4 = this.createStep({ x: 60, y: 420, w: 160, h: 60, text: "生成申请材料" });
      const step5 = this.createStep({ x: 60, y: 540, w: 160, h: 60, text: "网上提交审\n核签章材料" });
      const step6 = this.createDecision({ x: 90, y: 670, w: 160, h: 80, text: "申请材料\n形式审查" });

      const step6a = this.createStep({ x: 300, y: 500, w: 160, h: 60, text: "网上提交审\n核签章材料" });
      const step6b = this.createStep({ x: 300, y: 840, w: 160, h: 60, text: "出具不予受\n理通知书" });

      const step7 = this.createStep({ x: 60, y: 800, w: 160, h: 60, text: "出具行政审批事\n项受理通知书" });
      const step8 = this.createStep({ x: 60, y: 920, w: 160, h: 60, text: "组织专家技术评审" });
      const step9 = this.createStep({ x: 60, y: 1040, w: 160, h: 60, text: "科技部作出审批决定" });
      const step10 = this.createStep({ x: 60, y: 1160, w: 160, h: 60, text: "审批结果网上公布" });
      const step11 = this.createStep({ x: 60, y: 1280, w: 160, h: 60, text: "审批结果送达" });
      const line = new (this.createVerticalLine({ x1: 0, y1: 0, x2: 0, y2: 1360 }))({
        position: { x: 530, y: 20 },
      });

      const step12 = this.createStep({ x: 600, y: 60, w: 400, h: 60, text: "01 申请表\n网上平台签写" });
      // const step12 = this.createStep2({ x: 600, y: 60, w: 400, h: 60 });

      const step13 = this.createStep({ x: 600, y: 140, w: 400, h: 80, text: "02 法人资格材料\n法人资格材料如企业法人营业执照或事业单位法人证书或民办\n非企业单位登记证书等材料作为申请书附件上传" });
      const step14 = this.createStep({ x: 600, y: 240, w: 400, h: 80, text: "03 知情同意书文本\n作为申请书附件上传" });
      const step15 = this.createStep({ x: 600, y: 340, w: 400, h: 100, text: "04 伦理审查批件\n涉及多中心研究的，不可拆分申报，伦理审批件应包含审查意\n见、审查材料清单、签字盖章页、伦理委员会成员签到表等内\n容。审查材料如涉及版本号和版本日期应注明作为申请书附件\n上传" });
      const step16 = this.createStep({ x: 600, y: 460, w: 400, h: 60, text: '05 采集方案\n作为申请书附件上传' });
      const step17 = this.createStep({ x: 600, y: 540, w: 400, h: 60, text: '06 人类遗传资源管理制度\n作为申请书附件上传' });
      const step18 = this.createStep({ x: 600, y: 620, w: 400, h: 60, text: '07 合作协议\n如涉及，请提供签字盖章的协议作为申请书附件上传' });
      const step19 = this.createStep({ x: 600, y: 700, w: 400, h: 60, text: '08 其他证明材料\n如涉及，请提供作为申请书附件上传' });
      const step20 = this.createStep({ x: 900, y: 780, w: 100, h: 40, text: "下载模板" });
      this.graph.addCells([
        step1,
        step2,
        step3,
        step4,
        step5,
        step6,
        step6a,
        step6b,
        step7,
        step8,
        step9,
        step10,
        step11,
        line,
        title1,
        title2,
        step12,
        step13,
        step14,
        step15,
        step16,
        step17,
        step18,
        step19,
        step20,
        this.createFlow(step1, step2, "bottom", "top"),
        this.createFlow(step2, step3, "bottom", "top"),
        this.createFlow(step3, step4, "bottom", "top"),
        this.createFlow(step4, step5, "bottom", "top"),
        this.createFlow(step5, step6, "bottom", "top"),
        this.createFlow(step6, step6a, "right", "bottom").labels([
          {
            attrs: { labelText: { text: "材料不齐全\n或不符合规\n定形式" } },
            position: {
              offset: {
                x: 6,
                y: -70
              }
            }
          }
        ]),

        this.createFlow(step6, step6b, "right", "top").labels([
          {
            attrs: { labelText: { text: "不属于许可\n受理范围" } },
            position: {
              offset: {
                x: 6,
                y: 65
              }
            }
          }
        ]),

        this.createFlow(step6, step7, "bottom", "top"),
        this.createFlow(step7, step8, "bottom", "top"),
        this.createFlow(step8, step9, "bottom", "top"),
        this.createFlow(step9, step10, "bottom", "top"),
        this.createFlow(step10, step11, "bottom", "top"),
      ]);

      this.paper.on('element:pointerclick', (elementView, evt) => {
        const { id } = elementView.model;
        if (id === step20.id) {
          const a = document.createElement('a');
          a.href = '/伦理审查材料模板.zip'
          a.download = '伦理审查材料模板.zip';
          a.click();
          setTimeout(() => {
            this.$message.success('模板下载完成')
          }, 1500)
        }
      });
    },
    transformToFitContent() {
      this.paper.transformToFitContent({
        padding: 30,
        contentArea: this.graphBBox,
        verticalAlign: "middle",
        horizontalAlign: "middle"
      });
    },
    eventHandle() {
      const { mask: MaskHighlighter, stroke: StrokeHighlighter } = highlighters;
      this.paper.on("cell:mouseenter", (cellView) => {
        let selector, padding;
        if (cellView.model.isLink()) {
          if (StrokeHighlighter.get(cellView, "selection")) return;
          // In case of a link, the frame is added around the label.
          selector = { label: 0, selector: "labelBody" };
          padding = unit / 2;
        } else {
          selector = "body";
          padding = unit;
        }
        const frame = MaskHighlighter.add(cellView, selector, "frame", {
          padding,
          layer: dia.Paper.Layers.FRONT,
          attrs: {
            "stroke-width": 1.5,
            "stroke-linejoin": "round"
          }
        });
        frame.el.classList.add("jj-frame");
      });

      this.paper.on("cell:mouseleave", () => {
        MaskHighlighter.removeAll(this.paper, "frame");
      });

      this.paper.on("link:pointerclick", (cellView) => {
        this.paper.removeTools();
        dia.HighlighterView.removeAll(this.paper);
        const snapAnchor = function (coords, endView) {
          const bbox = endView.model.getBBox();
          // Find the closest point on the bbox border.
          const point = bbox.pointNearestToPoint(coords);
          const center = bbox.center();
          // Snap the point to the center of the bbox if it's close enough.
          const snapRadius = 10;
          if (Math.abs(point.x - center.x) < snapRadius) {
            point.x = center.x;
          }
          if (Math.abs(point.y - center.y) < snapRadius) {
            point.y = center.y;
          }
          return point;
        };
        const toolsView = new dia.ToolsView({
          tools: [
            new linkTools.TargetAnchor({
              snap: snapAnchor,
              resetAnchor: cellView.model.prop(["target", "anchor"])
            }),
            new linkTools.SourceAnchor({
              snap: snapAnchor,
              resetAnchor: cellView.model.prop(["source", "anchor"])
            })
          ]
        });
        toolsView.el.classList.add("jj-flow-tools");
        cellView.addTools(toolsView);
        // Add copy of the link <path> element behind the link.
        // The selection link frame should be behind all elements and links.
        const strokeHighlighter = StrokeHighlighter.add(
          cellView,
          "root",
          "selection",
          {
            layer: dia.Paper.Layers.BACK
          }
        );
        strokeHighlighter.el.classList.add("jj-flow-selection");
      });
    },
    createText({ x, y, text }) {
      return dia.Element.define('custom.TextElement', {
        attrs: {
          text: {
            text, // 这里是你要显示的文字
            fill: 'white',            // 文字颜色
            'font-size': 20,          // 文字大小
            'font-weight': 'bold',          // 文字大小
            'text-anchor': 'middle',  // 文字对齐方式
            'ref-x': x,             // x 方向的相对位置
            'ref-y': y,             // y 方向的相对位置
            'y-alignment': 'middle'
          }
        }
      }, {
        markup: [{
          tagName: 'text',
          selector: 'text'
        }]
      });
    },
    createVerticalLine({ x1, y1, x2, y2 }) {
      return dia.Element.define('custom.VerticalLine', {
        attrs: {
          line: {
            x1,
            y1,
            x2,
            y2,
            stroke: 'white',
            'stroke-width': 1
          }
        }
      }, {
        markup: [{
          tagName: 'line',
          selector: 'line'
        }]
      });
    },
    createStart(x, y, text) {
      return new shapes.standard.Rectangle({
        position: { x: x + 10, y: y + 5 },
        size: { width: 80, height: 50 },
        z: 1,
        attrs: {
          body: {
            class: "jj-start-body",
            rx: 25,
            ry: 25
          },
          label: {
            class: "jj-start-text",
            ...fontAttributes,
            text
          }
        }
      });
    },
    createStep({ x = 0, y = 0, w = 100, h = 40, text = 'Hi' }) {
      return new shapes.standard.Path({
        position: { x, y },
        size: { width: w, height: h },
        z: 1,
        attrs: {
          body: {
            stroke: 'white',
            strokeWidth: 1,
            fill: fillColor,
            class: "jj-step-body",
            d: `M 0 ${bevel} ${bevel} 0 calc(w-${bevel}) 0 calc(w) ${bevel} calc(w) calc(h-${bevel}) calc(w-${bevel}) calc(h) ${bevel} calc(h) 0 calc(h-${bevel}) Z`
          },
          label: {
            ...fontAttributes,
            class: "jj-step-text",
            fill: 'white',
            text,
            textWrap: {
              width: w - 35,
              height: -spacing
            }
          }
        }
      });
    },
    createStep2({ x = 0, y = 0, w = 100, h = 40 }) {
      return new shapes.standard.Rectangle({
        position: { x, y },
        size: { width: w, height: h },
        attrs: {
          body: {
            fill: '#ffffff',
            stroke: '#000000',
            strokeWidth: 2,
            rx: 5, // 圆角
            ry: 5  // 圆角
          },
          label: {
            text: '', // 设置文本为空，下面使用 `text` 属性来设置带有样式的文本
            textWrap: {
              text: `<tspan font-weight="bold">这是标题</tspan> 这是内容`,
              width: -10, // 内边距
              height: -10
            },
            fontSize: 14,
            fontFamily: 'Arial, sans-serif',
            fill: '#000000',
            textAnchor: 'middle',
            yAlignment: 'middle',
            xAlignment: 'middle',
          }
        }
      });
    },
    createDecision({ x = 0, y = 0, w = 160, h = 80, text = 'Hi' }) {
      return new shapes.standard.Path({
        position: { x: x - 30, y: y - 10 },
        size: { width: w, height: h },
        z: 1,
        attrs: {
          body: {
            strokeWidth: 1,
            stroke: 'white',
            fill: fillColor,
            class: "jj-decision-body",
            d:
              "M 0 calc(0.5 * h) calc(0.5 * w) 0 calc(w) calc(0.5 * h) calc(0.5 * w) calc(h) Z"
          },
          label: {
            ...fontAttributes,
            class: "jj-decision-text",
            fill: 'white',
            text
          }
        }
      });
    },
    createFlow(source,
      target,
      sourceAnchor = "right",
      targetAnchor = "left") {
      return new shapes.standard.Link({
        source: { id: source.id, anchor: { name: sourceAnchor } },
        target: { id: target.id, anchor: { name: targetAnchor } },
        z: 2,
        attrs: {
          line: {
            stroke: 'white',
            class: "jj-flow-line",
            targetMarker: {
              class: "jj-flow-arrowhead",
              d: `M 0 0 L ${2 * unit} ${unit} L ${2 * unit} -${unit} Z`
            }
          },
          outline: {
            class: "jj-flow-outline",
            connection: true
          }
        },
        markup: [
          {
            tagName: "path",
            selector: "wrapper",
            attributes: {
              fill: "none",
              cursor: "pointer",
              stroke: "transparent",
              "stroke-linecap": "round"
            }
          },
          {
            tagName: "path",
            selector: "outline",
            attributes: {
              fill: "none",
              "pointer-events": "none"
            }
          },
          {
            tagName: "path",
            selector: "line",
            attributes: {
              fill: "none",
              "pointer-events": "none"
            }
          }
        ],
        defaultLabel: {
          attrs: {
            labelBody: {
              stroke: 'white',
              fill: fillColor,
              class: "jj-flow-label-body",
              ref: "labelText",
              d: `
                        M calc(x-${spacing}) calc(y-${spacing})
                        m 0 ${bevel} l ${bevel} -${bevel}
                        h calc(w+${2 * (spacing - bevel)}) l ${bevel} ${bevel}
                        v calc(h+${2 * (spacing - bevel)}) l -${bevel} ${bevel}
                        H calc(x-${spacing - bevel}) l -${bevel} -${bevel} Z
                    `
            },
            labelText: {
              ...fontAttributes,
              fill: 'white',
              class: "jj-flow-label-text",
              textAnchor: "middle",
              textVerticalAnchor: "middle",
            }
          },
          markup: [
            {
              tagName: "path",
              selector: "labelBody"
            },
            {
              tagName: "text",
              selector: "labelText"
            }
          ]
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.flow-chart-two {

  --jj-color1: white;
  --jj-color2: #707070;
  --jj-color3: #bdbdbd;
  --jj-color4: transparent;

  --step-stroke-color: var(--jj-color1);
  --step-fill-color: var(--jj-color2);
  --step-text-color: var(--jj-color1);

  --decision-stroke-color: var(--jj-color1);
  --decision-fill-color: var(--jj-color2);
  --decision-text-color: var(--jj-color1);

  --start-stroke-color: var(--jj-color1);
  --start-fill-color: var(--jj-color2);
  --start-text-color: var(--jj-color1);

  --flow-stroke-color: var(--jj-color1);
  --flow-label-stroke-color: var(--jj-color1);
  --flow-label-fill-color: var(--jj-color2);
  --flow-label-text-color: var(--jj-color1);

  --flow-selection-color: var(--jj-color4);
  --frame-color: var(--jj-color3);
  --background-color: red;

  position: absolute;
  left: 0;
  top: 0;
  width: 1100px;
  height: 1400px;

  .jj-start-body {
    fill: var(--start-fill-color);
    stroke: var(--start-stroke-color);
  }

  .jj-start-text {
    fill: var(--start-text-color);
  }

  .jj-decision-body {
    fill: var(--decision-fill-color);
    stroke: var(--decision-stroke-color);
    stroke-width: 3;
  }

  .jj-decision-text {
    fill: var(--decision-text-color);
  }

  .jj-flow-line {
    stroke: var(--flow-stroke-color);
    stroke-width: 1;
  }

  .jj-flow-outline {
    stroke: var(--background-color);
    stroke-width: calc(calc(var(--flow-spacing) * 2) + 1px);
  }

  .jj-flow-label-body {
    stroke: var(--flow-label-stroke-color);
    fill: var(--flow-label-fill-color);
    stroke-width: calc(var(--flow-spacing));
  }

  .jj-flow-label-text {
    fill: var(--flow-label-text-color);
  }

  .jj-flow-arrowhead {
    stroke: var(--flow-stroke-color);
    fill: var(--flow-stroke-color);
  }

  .jj-frame {
    fill: var(--frame-color);
  }

  .jj-flow-tools circle {
    stroke: var(--frame-color);
    fill: var(--background-color);
    stroke-width: 2;
  }

  .jj-flow-tools rect {
    stroke: var(--frame-color);
  }

  .jj-flow-selection {
    stroke: var(--flow-selection-color);
    stroke-width: 20px;
    stroke-linejoin: round;
    stroke-linecap: round;
    vector-effect: none;
  }

}
</style>
